import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'justificativas',
      component: LayoutPadrao,
      children: [
         {
            path: '/justificativas',
            name: 'justificativas',
            component: () => import('../pages/lista-justificativas/listar-justificativas.vue')
         }
      ]
   }
]
